<template>
  <div class="m-0 dbozone-font body">
    <div class="col-12 justify-content-center d-flex flex-row header-blessingDragon">
      <div class="px-3 col-3 p-0">
        <div class="heading-blessingDragon">{{ $t("result.round") }}</div>
        <div class="text-subhead-blessingDragon">{{ data.roundId }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-blessingDragon">
          {{ $t("result.bet") + `${currency}` }}
        </div>
        <div class="text-subhead-blessingDragon">
          {{ (data.count === 0
            ? data.bet
            : data.detail.summary[data.count].bet.amount) | currencyFormatter }}
        </div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-blessingDragon">
          {{ $t("result.winlose") + `${currency}` }}
        </div>
        <div class="text-subhead-blessingDragon">
          {{ (winlose) | currencyFormatter }}
        </div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-blessingDragon">
          {{ $t("result.balance") + `${currency}` }}
        </div>
        <div class="text-subhead-blessingDragon">
          {{ (balance) | currencyFormatter }}
        </div>
      </div>
    </div>
    <div class="content-result-blessingDragon pt-3">
      <div class="text-games-blessingDragon">{{ "Blessing of the dragon" }}</div>
      <div class="text-subgame-blessingDragon">{{ $t("blessingDragon.name") }}</div>
      <div class="text-date mb-1">{{ data.timestamp }}</div>
      <div class="col-12 justify-content-center d-flex flex-row p-0 align-items-center" style="margin-top: 100px">
        <div class="col-1 d-flex align-items-center justify-content-center" style="color: white">
          <i v-if="isFreespin || isRespin" class="fas fa-caret-left arrow-side-blessingDragon" @click="delCount()" />
        </div>
        <div class="d-flex flex-column">
          <div class="d-flex flex-row justify-content-center">
            <img v-if="isFreespin" class="d-flex col-8 mb-4"
              :src="require(`../../assets/resultGame/blessingDragon/free_multiplier_${multiplier}.png`)" alt="" />
            <img v-if="isFreespin === false" class="d-flex col-8 mb-4"
              :src="require(`../../assets/resultGame/blessingDragon/normal_multiplier_${multiplier}.png`)" alt="" />
          </div>
          <div class="d-flex flex-row slot-container">
            <div class="d-flex flex-column">
              <div v-for="(reel, index) in reels[0]" :key="index">
                <img v-if="reel > 10 && isFreespin" class="icon-symbol-blessingDragon"
                  :src="require(`../../assets/resultGame/blessingDragon/1/symbol_${reel}_free.png`)" alt="" />
                <img v-else-if="reel > 10 && !isFreespin" class="icon-symbol-blessingDragon"
                  :src="require(`../../assets/resultGame/blessingDragon/1/symbol_${reel}_normal.png`)" alt="" />
                <img v-else class="icon-symbol-blessingDragon"
                  :src="require(`../../assets/resultGame/blessingDragon/1/symbol_${reel}.png`)" alt="" />
              </div>
            </div>
            <div class="d-flex flex-column">
              <div v-for="(reel, index) in reels[1]" :key="index">
                <img v-if="reel > 10 && isFreespin" class="icon-symbol-blessingDragon"
                  :src="require(`../../assets/resultGame/blessingDragon/1/symbol_${reel}_free.png`)" alt="" />
                <img v-else-if="reel > 10 && !isFreespin" class="icon-symbol-blessingDragon"
                  :src="require(`../../assets/resultGame/blessingDragon/1/symbol_${reel}_normal.png`)" alt="" />
                <img v-else class="icon-symbol-blessingDragon"
                  :src="require(`../../assets/resultGame/blessingDragon/1/symbol_${reel}.png`)" alt="" />
              </div>
            </div>
            <div class="d-flex flex-column">
              <div v-for="(reel, index) in reels[2]" :key="index">
                <img v-if="reel > 10 && isFreespin" class="icon-symbol-blessingDragon"
                  :src="require(`../../assets/resultGame/blessingDragon/1/symbol_${reel}_free.png`)" alt="" />
                <img v-else-if="reel > 10 && !isFreespin" class="icon-symbol-blessingDragon"
                  :src="require(`../../assets/resultGame/blessingDragon/1/symbol_${reel}_normal.png`)" alt="" />
                <img v-else class="icon-symbol-blessingDragon"
                  :src="require(`../../assets/resultGame/blessingDragon/1/symbol_${reel}.png`)" alt="" />
              </div>
            </div>
            <div class="d-flex flex-column">
              <div v-for="(reel, index) in reels[3]" :key="index">
                <img v-if="reel > 10 && isFreespin" class="icon-symbol-blessingDragon"
                  :src="require(`../../assets/resultGame/blessingDragon/1/symbol_${reel}_free.png`)" alt="" />
                <img v-else-if="reel > 10 && !isFreespin" class="icon-symbol-blessingDragon"
                  :src="require(`../../assets/resultGame/blessingDragon/1/symbol_${reel}_normal.png`)" alt="" />
                <img v-else class="icon-symbol-blessingDragon"
                  :src="require(`../../assets/resultGame/blessingDragon/1/symbol_${reel}.png`)" alt="" />
              </div>
            </div>
            <div class="d-flex flex-row slot-container">
              <div class="d-flex flex-column">
                <div v-for="(reel, index) in reels[4]" :key="index">
                  <img v-if="reel > 10 && isFreespin" class="icon-symbol-blessingDragon"
                    :src="require(`../../assets/resultGame/blessingDragon/1/symbol_${reel}_free.png`)" alt="" />
                  <img v-else-if="reel > 10 && !isFreespin" class="icon-symbol-blessingDragon"
                    :src="require(`../../assets/resultGame/blessingDragon/1/symbol_${reel}_normal.png`)" alt="" />
                  <img v-else class="icon-symbol-blessingDragon"
                    :src="require(`../../assets/resultGame/blessingDragon/1/symbol_${reel}.png`)" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-1 d-flex align-items-center justify-content-center">
          <i v-if="!isEndRound" class="fas fa-caret-right arrow-side-blessingDragon" @click="addCount()"></i>
        </div>
      </div>
      <div class="text-center py-4 text-games-blessingDragon">
        <h1 v-if="isFreespin">
          FREESPIN {{ data.count + 1 }}/{{ data.detail.summary.length }}
        </h1>
        <h1 v-else>SPIN {{ data.count + 1 }}/{{ data.detail.summary.length }}</h1>
      </div>
      <div v-if="winnings.length > 0" class="col-12 justify-content-center d-flex flex-row">
        <hr class="line col-3" />
        <div class="text-detail align-items-center d-flex px-3">
          {{ $t("result.detail") }}
        </div>
        <hr class="line col-3" />
      </div>
      <div v-if="data.detail.featureBuy" class="text-subgame-blessingDragon">
        Feature Buy
      </div>

      <div v-if="winnings.length" class="col-12 justify-content-start d-flex flex-row align-items-center">
        <div class=" bet-box-blessingDragon p-2 px-3 justify-content-start align-items-center container">
          <h1 class="my-1 green">Multiplier x {{ multiplier }}</h1>
          <div class="bet-warpper justify-content-between item d-flex col-12" v-for="(detail, index) in winnings"
            :key="index">
            <div class="d-flex flex-row">
              <img class="icon-detail-blessingDragon"
                :src="require(`../../assets/resultGame/blessingDragon/1/symbol_${detail.symbol}.png`)" alt="" />
              <div class="d-flex text-win align-items-center justify-content-center">
                <p class="my-1 green">{{ ` ${detail.row} ` + $t("result.kind") + ` x${detail.count} ${detail.count > 1 ?
                  `lines` : `line`}` }}</p>
              </div>
            </div>
            <div class="d-flex text-win justify-content-center align-items-center px-3">
              <p class="my-1 green"> {{ currency }} {{ detail.amount | currencyFormatter }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../../services/utils";
export default {
  name: "result-blessingDragon",
  props: {
    data: Object,
    page: Number,
    isback: Boolean
  },
  data() {
    return {
      headerHeight: null,
      dateTimeFormatter: function formatter(date) {
        return utils.dateTimeFormatter(date);
      },
      tokenData: utils.getTokenData(this.$route.query.t)
      ,
      date: "",
      time: "",
      currency: this.data.currency ? this.data.currency : "THB",
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
      isFreespin: false,
      multiplier: 0,
      reels: [],
      isEndRound: false,
      pages: 0
    };
  },
  async created() {
    if (this.isback) {
      this.data.count = this.data.detail.summary.length - 1;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
    else {
      this.data.count = 0;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
  },
  methods: {
    onResize() {
      this.headerHeight =
        document.getElementsByClassName("header-blessingDragon")[0].offsetHeight;
    },

    async mapSymbol(result) {
      if (!this.currency.includes("(")) {
        this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
      }
      this.isFreespin =
        result.state === "FREESPIN" ||
        result.state === "FREERESPIN";
      this.isRespin = result.state === "RESPIN";
      this.reels = result.reels;
      this.multiplier = result.multiplier;

      this.isEndRound = result.isEndRound;
      this.winlose = result.win;
      this.bet = result.bet;
      this.balance = result.balance;
      this.winnings = result.winnings;

      if (result.isCoin) this.currency = 'AMS';
    },
    async addCount() {
      this.data.count += 1;
      if (this.data.count > this.data.detail.summary.length - 1) {
        this.pages += 1;
        this.$emit('fetchResult', this.page + 1)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }

    },
    async delCount() {
      this.data.count -= 1;
      if (this.page > 0) {
        this.pages -= 1;
        this.$emit('fetchResult', this.page - 1, true)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }
    },
  },
};
</script>

<style scoped>
body {
  font-family: "Prompt", sans-serif;
  background-color: #292933;
  /* margin: 0; */
}

img {
  pointer-events: none;
  cursor: default;
}

.wheel-wrapper {
  position: absolute;
  width: 570px;
  height: 100%;
  top: 7px;
}

.fg-image {
  width: 570px;
}


.multiplier-wrapper {
  top: -95px;
  z-index: 6;
  height: 134px;
  overflow: hidden;
}

.multiplier-image {
  width: 90%;
  transform: scale(0.9);
  margin-left: 21px;
}

.icon-detail-blessingDragon {
  width: 100px;
  height: 80px;
  padding: 4px;
}

.icon-bonus-blessingDragon {
  width: 100px;
  height: 100px;
  padding: 10px;
}

.arrow {
  color: #cac095;
  text-align: center;
}

.arrow-side-blessingDragon {
  cursor: pointer;
  color: #ffff;
  text-align: center;
  font-size: 90px;
}

.arrow-side-monster:hover {
  color: #06112d;
  text-align: center;
  /* font-size: 90px; */
}

.bet-box-blessingDragon {
  /* background: #434141; */
  border-radius: 10px;
  min-height: 200px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.bonus-box-blessingDragon {
  background: #0c161f;
  border-radius: 10px;
  min-height: 150px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bet-wrapper-blessingDragon .item {
  color: #fff;
  background: #06112d;
  line-height: 1;
  border-radius: 10px;
  /* border: 1.5px solid #cac095; */
}

.bet-box-blessingDragon .bet-wrapper-blessingDragon:not(:first-child) .item {
  /* margin-top: 10px;
  width: 800px; */
}

.bet-wrapper-blessingDragon,
.result-wrapper {
  font-size: 35px;
  width: 800px;
}

.header-blessingDragon {
  background: #3C3A3A;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header-blessingDragon>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-blessingDragon {
  color: #F3B04B;
  text-align: center;
}

.content-result-blessingDragon {
  background: #434141;
  height: 150vh;
  width: 100%;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.title>.heading-blessingDragon {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title>.sub {
  font-size: 30px;
  line-height: 1;
}

.text-games-blessingDragon {
  color: #F3B04B;
  font-size: 25px;
  text-align: center;
}

.text-collect-blessingDragon {
  color: #fff;
  font-size: 25px;
  text-align: center;
}

.text-subhead-blessingDragon {
  font-size: px;
  color: #fff;
  text-align: center;
}

.text-subgame-blessingDragon {
  font-size: 20px;
  color: #F3B04B;
  text-align: center;
}

.text-date {
  font-size: px;
  color: #fff;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #fff;
  text-align: center;
}

.icon-symbol-blessingDragon {
  width: 100%;
  /* height: 100%; */
  /* padding: 5%; */
}

.gamble-normal-blessingDragon {
  width: 40%;
  height: 35%;
  /* padding: 5%; */
}

.gamble-press-blessingDragon {
  width: 40%;
  height: 40%;
  /* padding: 5%; */
}

.gamble-img-blessingDragon {
  width: 70%;
  height: 70%;
  /* padding: 5%; */
}

.bet-box-blessingDragon {
  /* min-width: 600px;
  max-width: auto; */
}

.win-box {
  width: 760px;
}

.icon-symbol {
  position: absolute;
  transform: translate(-100%, 0%);
  width: 16.75%;
  /* height: 100%; */
}

/* .icon-symbol.-level1 {
  width: 120;
  height: 89px;
}

.icon-symbol.-level2 {
  width: 120;
  height: 128;
  margin-left: -12px;
}

.icon-symbol.-level3 {
  width: 120;
  height: 330px;
  margin-left: -12px;
}

.icon-symbol.-level4 {
  width: 120;
  height: 442px;
  margin-left: -12px;
} */

.table-blessingDragon {
  background: url("~@/assets/resultGame/blessingDragon/slotmachine.png") no-repeat;
  z-index: 5;
  background-size: 763px 186px;
  /* set Bg Table HERE */
  width: 763px;
  height: 268px;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
  margin-top: 48px;
  position: absolute;
  z-index: 0;
  transform: translate(0px, -130px);
}

.slot-container {
  position: relative;
}

.top-reel {
  display: flex;
  flex-direction: row;
  position: relative;
  width: 67%;
  transform: translate(24.5%, 0%);
}

.table-pos {
  transform: translate(0px, -7px);
}

.text-multiplier {
  width: 100%;
  text-align: center;
}

.line {
  background-color: #fff;
  height: 2px;
  width: 100%;
  font-size: 28px;
}

.red {
  color: #ff0000;
}

.green {
  color: #fff;
  font-size: 28px;
}

.win-box {
  width: 689px;
}





@media screen and (max-width: 1030px) {
  .table-blessingDragon {
    background-size: 760px 181px;
    width: 760px;
    height: 268px;
    transform: translate(0px, -124px);
  }

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .fg-image {
    width: 500px;
  }

  .multiplier-wrapper {
    top: -107px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-monster {
    font-size: 60px;
  }

  .bet-box-blessingDragon {
    /* min-width: 580px;
    max-width: auto;
    height: 280px; */
  }

  .bet-wrapper-blessingDragon {
    width: 800px;
  }

  .result-wrapper {
    font-size: 35px;
    width: 800px;
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (max-width: 1030px) {
  .table-blessingDragon {
    background-size: 760px 640px;
    width: 760px;
    height: 640px;
    transform: translate(0px, -55px);
  }

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .fg-image {
    width: 500px;
  }

  .multiplier-wrapper {
    top: -107px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-monster {
    font-size: 60px;
  }

  .bet-box-blessingDragon {
    /* min-width: 580px;
    max-width: auto; */
    /* height: 280px; */
  }

  .bet-wrapper-blessingDragon {
    width: 800px
  }

  .result-wrapper {
    font-size: 35px;
    width: 800px
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (min-width: 1060px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -115px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 570px;
    margin-left: -34px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(1);
    margin-left: 21px;
  }

  .d-md-spec-flex {
    display: flex;
  }

  .result-wrapper .symbol {
    width: 140px;
  }

  .bet-wrapper-blessingDragon,
  .result-wrapper {
    font-size: 33px;
    width: 800px;
  }
}

@media screen and (max-width: 900px) {
  .table-blessingDragon {
    background-size: 747px 645px;
    width: 747px;
    height: 645px;
    transform: translate(0px, -58px);
  }
}

@media screen and (max-width: 870px) {
  .table-blessingDragon {
    background-size: 729px 628px;
    width: 729px;
    height: 628px;
    transform: translate(-2px, -59px);
  }
}

@media screen and (max-width: 840px) {
  .table-blessingDragon {
    background-size: 699px 602px;
    width: 699px;
    height: 602px;
    transform: translate(0px, -57px);
  }
}

@media screen and (max-width: 800px) {
  .table-blessingDragon {
    background-size: 659px 569px;
    width: 659px;
    height: 569px;
    transform: translate(0px, -56px);
  }
}

@media screen and (max-width: 780px) {}

@media screen and (max-width: 770px) {
  .heading-blessingDragon {
    font-size: 18px;
  }

  .table-blessingDragon {
    background-size: 638px 550px;
    width: 638px;
    height: 550px;
    margin-bottom: 1%;
    transform: translate(0px, -55px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-blessingDragon {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-blessingDragon {
    /* min-width: 430px;
    max-width: auto; */
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (max-width: 740px) {
  .heading-blessingDragon {
    font-size: 18px;
  }

  .table-blessingDragon {
    background-size: 614px 526px;
    width: 614px;
    height: 526px;
    margin-bottom: 1%;
    transform: translate(0px, -53px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-blessingDragon {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-blessingDragon {
    /* min-width: 430px;
    max-width: auto; */
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (max-width: 710px) {
  .heading-blessingDragon {
    font-size: 18px;
  }

  .table-blessingDragon {
    background-size: 582px 500px;
    width: 582px;
    height: 500px;
    margin-bottom: 1%;
    transform: translate(-2px, -54px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-blessingDragon {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-blessingDragon {
    /* min-width: 430px;
    max-width: auto; */
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (max-width: 680px) {
  .heading-blessingDragon {
    font-size: 18px;
  }

  .table-blessingDragon {
    background-size: 566px 482px;
    width: 566px;
    height: 482px;
    margin-bottom: 1%;
    transform: translate(-1px, -55px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-blessingDragon {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-blessingDragon {
    /* min-width: 430px;
    max-width: auto; */
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (max-width: 650px) {
  .heading-blessingDragon {
    font-size: 18px;
  }

  .table-blessingDragon {
    background-size: 543px 470px;
    width: 543px;
    height: 470px;
    margin-bottom: 1%;
    transform: translate(0px, -56px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-blessingDragon {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-blessingDragon {
    /* min-width: 430px;
    max-width: auto; */
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (max-width: 620px) {
  .heading-blessingDragon {
    font-size: 18px;
  }

  .table-blessingDragon {
    background-size: 516px 444px;
    width: 516px;
    height: 444px;
    margin-bottom: 1%;
    transform: translate(-2px, -53px);
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .text-subhead-blessingDragon {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-blessingDragon {
    /* min-width: 430px;
    max-width: auto; */
  }

  .text-date {
    font-size: 20px;
    color: #fff;
    text-align: center;
  }

  .win-box {
    width: 689px;
  }
}

@media screen and (max-width: 600px) {
  .table-blessingDragon {
    background-size: 498px 430px;
    width: 498px;
    height: 430px;
    transform: translate(0px, -54px);
  }
}

@media screen and (max-width: 570px) {
  .table-blessingDragon {
    background-size: 474px 410px;
    width: 474px;
    height: 410px;
    transform: translate(0px, -53px);
  }
}

@media screen and (max-width: 540px) {
  .table-blessingDragon {
    background-size: 450px 390px;
    width: 450px;
    height: 390px;
    transform: translate(-1px, -54px);
  }

  .text-multiplier {
    width: 100%;
    text-align: center;
  }
}

@media screen and (max-width: 510px) {
  .table-blessingDragon {
    background-size: 425px 367px;
    width: 425px;
    height: 367px;
    transform: translate(0px, -54px);
  }
}

@media screen and (max-width: 480px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 230px;
    height: 189px;
    margin-left: 135px;
    margin-top: -9px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.4);
    margin-left: 21px;
  }

  .header-blessingDragon>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-blessingDragon {
    font-size: 12px;
  }

  .table-blessingDragon {
    background-size: 399px 344px;
    width: 399px;
    height: 344px;
    transform: translate(-1px, -53px);
  }

  .text-subhead-blessingDragon {
    font-size: 14px;
  }

  .bet-box-blessingDragon {
    /* min-width: 230px;
    max-width: auto; */
    /* height: 200px; */
  }

  .bonus-box-blessingDragon {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  .bet-wrapper-blessingDragon {
    width: 422px;
  }

  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-blessingDragon {
    width: 50px;
    height: 50px;
  }

  .text-win {
    height: 60px;
  }

  .text-multiplier {
    width: 100%;
    text-align: center;
  }

  .icon-bonus-blessingDragon {
    width: 60px;
    height: 60px;
  }
}

@media screen and (max-width: 450px) {
  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 230px;
    height: 189px;
    margin-left: 135px;
    margin-top: -9px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.4);
    margin-left: 21px;
  }

  .header-blessingDragon>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-blessingDragon {
    font-size: 12px;
  }

  .table-blessingDragon {
    background-size: 375px 324px;
    width: 375px;
    height: 324px;
    transform: translate(-1px, -53px);
  }

  .text-subhead-blessingDragon {
    font-size: 14px;
  }

  .bet-box-blessingDragon {
    /* min-width: 230px;
    max-width: auto; */
    /* height: 200px; */
  }

  .bonus-box-blessingDragon {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  .bet-wrapper-blessingDragon {
    width: 422px;
  }

  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-blessingDragon {
    width: 50px;
    height: 50px;
  }

  .text-multiplier {
    width: 100%;
    text-align: center;
  }

  .icon-bonus-blessingDragon {
    width: 60px;
    height: 60px;
  }
}

@media screen and (max-width: 420px) {

  .table-blessingDragon {
    background-size: 350px 300px;
    width: 350px;
    height: 300px;
    transform: translate(1px, -52px);
  }
}

@media screen and (max-width: 390px) {

  .table-blessingDragon {
    background-size: 325px 280px;
    width: 325px;
    height: 280px;
    transform: translate(0px, -53px);
  }
}

@media screen and (max-width: 360px) {

  .table-blessingDragon {
    background-size: 300px 100px;
    width: 399px;
    height: 180px;
    transform: translate(0px, -93px);
  }

}

@media screen and (max-width: 340px) {

  .table-blessingDragon {
    background-size: 279px 100px;
    width: 399px;
    height: 180px;
    transform: translate(2px, -93px);
  }
}

@media screen and (max-width: 320px) {

  .table-blessingDragon {
    background-size: 259px 64px;
    width: 399px;
    height: 180px;
    transform: translate(4px, -76px);
  }
}
</style>